<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-16 11:07:52
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-06-13 17:10:43
-->
<template>
  <div :class="`order-card ${customClass||''} ${margin?'margin-top-3':''}`" @click="$emit('click')" >
      <div class="order-card-content" :class="border?'border':''">
        <div class="card-left-label van-ellipsis" style="font-size: 3.7vw;" v-if="labelValue">
            {{labelValue}}
        </div>
        <div class="order-left-row" v-if="text||icon||label">
            <div class="order-left-text">
                    <div v-if="icon" class="icon" :class="`${icon}-icon`"></div>
                    <div style="flex:1;font-weight: bold;">{{text}}</div>
            </div>
            <div v-if="label" class="label">{{label}}</div>
        </div>
        <div class="value" :style="`width:${valueWidth}`" v-if="value" @click="valueClick">
            <div  :style="`color:${color}`" >{{value}}</div>
            <div v-if="valueLable">{{valueLable}}</div>
        </div>
        <div style="color:#CBCCD1;margin-left:1.6vw" v-if="rightIcon"><van-icon name="arrow" /></div>
        <div class="rightButton" v-if="buttonText" @click="buttonClick">{{buttonText}}</div>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        icon:{
            type:String,
            default:''
        },
        text:{
           type:String,
            default:'' 
        },
        rightIcon:{
            type:Boolean,
            default:true
        },
        label:{
           type:String,
            default:''   
        },
        labelValue:{
            type:String,
            default:''   
        },
        value:{
           type:String,
            default:''   
        },
        valueLable:{
            type:String,
            default:''    
        },
        valueWidth:{
            type:String,
            default:'55vw'    
        },
        margin:{
           type:Boolean,
            default:true 
        },
        border:{
            type:[Boolean,Number,String],
            default:false 
        },
        color:{
            type:String,
            default:'#43464D'   
        },
        buttonText:{
            type:String,
            default:''   
        },
        customClass:{
            type:String,
            default:''
        }
    },
    methods:{
        valueClick(){
            this.$emit('valueClick')
        },
        buttonClick(){
            console.log('this.$emit()',this.$emit('buttonClick'))
            this.$emit('buttonClick')
        }
    }
}
</script>

<style scoped>
.margin-top-3{
    margin-top: 3.7vw;
}
.order-card{
   padding:0 3.7vw;
    background-color: #ffffff;
    border-radius: 2.1vw;
}
.order-card-content{
    position: relative;
    font-size: 4.2vw;
    color: #333333;
    display: flex;
    align-items: center;
    padding: 5.3vw 0;
}
.order-card .icon{
    width: 5.3vw;
    height: 5.3vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 2.8vw;
}
.order-card .value{
    width: 55vw;
    text-align: right;
    font-size: 4vw;
    font-weight: 400;
    display: inline-block;
}
.address-icon{
    background-image: url('../../../assets/order-card-icon-01.png');
}
.car-icon{
     background-image: url('../../../assets/card.png');
}
.order-left-row{
    flex: 1;
    display: inline-block;
}
.order-left-text{
    display: flex;
    /* align-items: center; */
}
.order-left-row .label{
    color:#999999;
    font-size: 3.7vw;
    margin-top: 2.3vw;
    padding-left: 8.1vw;
    display: inline-block;
}
.border{
    border-bottom: 1px solid #F5F5F5;
}
.rightButton{
    position: absolute;
    right:-1vw;
    bottom: 3vw;
    border:1px solid #00BCD1;
    color: #00BCD1;
    font-size: 3.2vw;
    height: 8vw;
    line-height: 8vw;
    border-radius: 1vw;
    display: inline-block;
    width: 21vw;
    text-align: center;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/servicePackage/components/OrderCard.vue